var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"id":"gfs:icon1/pause","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"M9.75 5v14H9.5A1.5 1.5 0 018 17.5V5h1.75zm6 0v14h-.25a1.5 1.5 0 01-1.5-1.5V5h1.75z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }